module.exports = __webpack_public_path__ + "img/logo_blank.fb48e5cc.png";